import React, { memo, PureComponent } from 'react';
import { connect } from 'react-redux';
import { Modal, InputGroup, Form, Button, FormControl } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStore, faTruck, faSpinner, faTh, faCheck, faSearch } from '@fortawesome/free-solid-svg-icons';

import { SiteRutas } from "../../../request/RutasConfig";
import { Notificacion } from '../../../components/Util/Notificacion/Notificacion';
import { formatearCantidad, countDecimals, validarInt } from '../../../components/Util/Util.js';
import { Modificar_Detalle_Orden_Articulo_Validado_Request } from "../../../request/SubOrdenDetalleRequest";
import { Validar_Articulo_Despacho_Request } from "../../../request/ArticuloRequest";
import ListaDatos from '../../../components/UI/listaDatosBusqueda/listaDatos.jsx';

class despacharOrdenes extends PureComponent {
    _isMounted = false;
    state = {
        columnas: [],
        confirmoLectura: false,
        showModalValidacion: false,
        codigoValidar: '',
        articuloActual: '',
        articulos: []
    }

    componentDidMount() {
        this._isMounted = true;
        this.setState({ articulos: this.props.articulosTotales });
        this.configurarColumnas();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps) {

        if (this.props.aplicaLotes !== prevProps.aplicaLotes || this.props.editable !== prevProps.editable || this.props.parametrosGenerales !== prevProps.parametrosGenerales || this.props.validarArticulo !== prevProps.validarArticulo) {
            this.configurarColumnas();
        }

        if (this.props.articulosTotales !== prevProps.articulosTotales) {
            this.setState({ articulos: this.props.articulosTotales });
        }
    }

    modificar_detalle_articulo_validado = async () => {
        const respuesta = await Modificar_Detalle_Orden_Articulo_Validado_Request(this.props.token, this.props.empresa.Id, this.props.sucursal.Id, this.props.ordenUbicacion.Orden, this.props.callCenter.Id, this.state.articuloActual);
        if (respuesta.Exitoso) {
            this.setState({ articulos: [] }, () => {
                this.props.onSetValidacionArticulo(this.state.articuloActual);
                this.onCloseModalValidacion();
            });
        }
        else {
            if (respuesta.CodigoError === 2) {
                Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                this.props.history.replace(SiteRutas.Login);
                return;
            }
            Notificacion.error('Error: ' + respuesta.Mensaje);
        }
    }

    validar_Articulo_Despacho = async () => {
        const respuesta = await Validar_Articulo_Despacho_Request(this.props.token, this.props.empresa.Id, this.state.articuloActual, this.state.codigoValidar);
        if (respuesta.Exitoso) {
            if (respuesta.Datos) {
                this.modificar_detalle_articulo_validado();
            }
            else {
                Notificacion.error('Error: El código no corresponde al artículo.');
            }
        }
        else {
            if (respuesta.CodigoError === 2) {
                Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                this.props.history.replace(SiteRutas.Login);
                return;
            }
            Notificacion.error(`Error: ${respuesta.Mensaje}`);
        }
    }

    configurarColumnas = () => {

        let columnas = [
            { dataField: 'Articulo_Id', text: 'Código', sort: true, editable: false, align: 'left' },
            { dataField: 'Articulo_Codigo_Principal', text: 'Código Principal', sort: true, editable: false, align: 'left' },
            { dataField: 'Articulo_Nombre', text: 'Descripción', sort: true, editable: false, align: 'left', classes: 'break-word' },
            {
                dataField: 'Detalle_Pedido_Sucursal', text: 'Cantidad', sort: true, editable: false, align: 'left',
                formatter: (cell, row) => { return formatearCantidad(row.Detalle_Pedido_Sucursal, row.Articulo_Decimales, this.props.parametrosGenerales.Maximo_Decimales_Articulo_Cantidad) }, headerStyle: { width: '100px' }, style: { width: '100px' }
            },
            {
                dataField: 'Detalle_Facturar', text: 'Despachado', sort: false, editable: this.props.editable, align: 'left',
                formatter: (cell, row) => { return formatearCantidad(row.Detalle_Facturar, row.Articulo_Decimales, this.props.parametrosGenerales.Maximo_Decimales_Articulo_Cantidad) },
                headerStyle: { width: '150px' }, style: { width: '150px' },
                validator: (newValue, row, column) => {
                    if (isNaN(newValue)) {
                        Notificacion.error('Debe ingresar un dato válido');
                        return { valid: false };
                    }
                    let isValid = newValue >= 0;
                    if (!isValid) {
                        Notificacion.error('El despachado debe ser cantidad positiva ');
                        return { valid: false };
                    }
                    isValid = row.Articulo_Decimales || validarInt(newValue);
                    if (!isValid) {
                        Notificacion.error('El despachado no debe tener decimales ');
                        return { valid: false };
                    }
                    if (row.Articulo_Decimales && countDecimals(parseFloat(newValue)) > this.props.parametrosGenerales.Maximo_Decimales_Articulo_Cantidad) {
                        Notificacion.error(`El despachado no debe tener más de ${this.props.parametrosGenerales.Maximo_Decimales_Articulo_Cantidad} decimales.`);
                        return { valid: false };
                    }
                    isValid = newValue <= row.Detalle_Pedido_Sucursal;
                    if (!isValid) {
                        Notificacion.error(`El despachado supera la cantidad: ${formatearCantidad(row.Detalle_Pedido_Sucursal, row.Articulo_Decimales, this.props.parametrosGenerales.Maximo_Decimales_Articulo_Cantidad)}`);
                        return { valid: false };
                    }
                    return true;
                }
            }
        ];

        if (this.props.validarArticulo) {
            columnas.push({
                dataField: 'Detalle_Articulo_Validado',
                text: 'Validado',
                editable: false,
                align: 'center',
                headerStyle: { width: '77px' },
                style: { width: '77px' },
                formatter: (cellContent, row) => {
                    return (
                        row.Detalle_Articulo_Validado ?
                            <i style={{ color: '#696969' }} title="Validado"><FontAwesomeIcon icon={faCheck} /></i>
                            : <div className="btn-group">
                                <button className="btn btn-success"
                                    onClick={(event) => this.onClickBtnOpenValidar(event, row.Articulo_Id)}
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    title="Validar"
                                    style={{ backgroundColor: "#00a65a", color: "#fff" }}>
                                    <FontAwesomeIcon icon={faSearch} />
                                </button>
                            </div>
                    );
                }
            });
        }

        if (this.props.aplicaLotes && this.props.editable) {
            columnas.unshift({
                dataField: 'Aplica_Lote', text: 'Lotes', align: 'center', editable: false,
                headerStyle: { width: '57px' }, style: { width: '57px' },
                formatter: (cellContent, row) => {
                    return (
                        row.Aplica_Lote ?
                            <div className="btn-group">
                                <button className="btn btn-success"
                                    onClick={this.props.onClickLotes}
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    title="Aplica Lote"
                                    style={{ backgroundColor: "#00a65a", color: "#fff" }}>
                                    <FontAwesomeIcon icon={faTh} />
                                </button>
                            </div>
                            : null
                    );
                }
            });
        }

        this._isMounted && this.setState({ columnas });
    }

    onChangeConfirmoLectura = (event) => {
        const { checked } = event.target;
        this._isMounted && this.setState({ confirmoLectura: checked });
    }

    onClickBtnDespachar = () => {
        if (this.props.ordenUbicacion && this.props.ordenUbicacion.Instrucciones_Entrega && !this.state.confirmoLectura) {
            Notificacion.error("Debe confirmar la lectura de las instrucciones de entrega.");
        }
        else {
            const { articulos } = this.state;
            if (this.props.validarArticulo && articulos && articulos.length > 0 && articulos.some(item => !item.Detalle_Articulo_Validado) ) {
                Notificacion.error("Debe validar todos los artículos para poder despachar.");
            }
            else {
                this.props.onClick();
            }
        }
    }

    onClickBtnOpenValidar = (event, pArticulo_Id) => {
        event.stopPropagation();
        this.setState({ showModalValidacion: true, codigoValidar: '', articuloActual: pArticulo_Id });
    }

    onClickBtnValidar = () => {
        this.validar_Articulo_Despacho();
    }

    onCloseModalValidacion = () => {
        this.setState({ showModalValidacion: false, codigoValidar: '', articuloActual: '' });
    }

    onChangeCodigoValidacion = (event) => {
        const { value } = event.target;
        this.setState({ codigoValidar: value });
    }

    onKeyDownCodigoValidacion = (event) => {
        const { value } = event.target;
        const code = event.which ? event.which : event.keyCode;
        if (code === 13) {
            this.setState({ codigoValidar: value }, () => {
                this.validar_Articulo_Despacho();
            });
        }
    };

    render() {
        const { confirmoLectura, columnas, codigoValidar, showModalValidacion, articulos } = this.state;
        const { ordenUbicacion, ordenGrupo, Eliminar, AnularDespacho } = this.props;

        const cellEdit2 = { mode: 'click', autoSelectText: true, blurToSave: false };
        const articulosDesp = articulos.filter((item) => item.Suc_Id == this.props.sucursal.Id);
        const ConDespacho = ordenUbicacion.ConDespacho && ordenUbicacion.ConDespacho.trim() ?
            <div className="row">
                <div className="col-6">
                    <form className="form-group general">
                        <label className="">Condición de Despacho </label><p>{ordenUbicacion.ConDespacho}</p>
                    </form>
                </div>
            </div>
            : null;

        const table = columnas ?
            <ListaDatos
                id={"Articulo_Id"}
                datos={articulosDesp}
                columnas={columnas}
                striped={false}
                hover={true}
                condensed={false}
                clases={'table-responsive'}
                verLHOC={false}
                onDoubleClick={() => { }}
                cellEdit={cellEdit2}
                borrar={false}
                buscar={false}
                paginacion={false}
            />
            : null;

        return (
            <>
                <Modal show={this.props.show} onHide={this.props.onClickCancelar} size="xl" backdrop="static" keyboard={false} enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title><h5 className="modal-title">Despachar Orden</h5></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-3">
                                <form className="form-group general">
                                    <label>Número de Express</label>
                                    <p>{ordenUbicacion.Orden}</p>
                                </form>
                            </div>
                            <div className="col-3">
                                <form className="form-group general">
                                    <label>Número de Ecommerce</label>
                                    <p>{ordenGrupo}</p>
                                </form>
                            </div>
                            <div className="col-3 mt-4">
                                <form className="form-group general">
                                    <p>  {ordenUbicacion.Tipo_Entrega === "PU" ?
                                        <FontAwesomeIcon icon={faStore}> Tienda </FontAwesomeIcon> :
                                        <FontAwesomeIcon icon={faTruck}> Domicilio</FontAwesomeIcon>}  {ordenUbicacion.Tipo_Entrega === "PU" ? ' Tienda' : ' Domicilio'}   </p>
                                </form>
                            </div>
                            <div className="col-3 mt-4">
                                <form className="form-group general">
                                    <p><i className={(ordenUbicacion.Apoyo == 'NO' ?
                                        ''
                                        : (ordenUbicacion.Apoyo == 'RA' ?
                                            "flaticon-inbox"
                                            : "flaticon-outbox"))}></i> {(ordenUbicacion.Apoyo == 'NO' ?
                                                ''
                                                : (ordenUbicacion.Apoyo == 'RA' ?
                                                    'Sucursal con Apoyo'
                                                    : 'Sucursal de Apoyo'))} </p>
                                </form>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3">
                                <form className="form-group general">
                                    <label>Correo</label>
                                    <p>{ordenUbicacion.Correo}</p>
                                </form>
                            </div>
                            <div className="col-3">
                                <form className="form-group general">
                                    <label>Cliente</label>
                                    <p>{ordenUbicacion.Nombre}</p>
                                </form>
                            </div>
                            <div className="col-3">
                                <form className="form-group general">
                                    <label>Teléfono</label>
                                    <p>{ordenUbicacion.Telefono}</p>
                                </form>
                            </div>
                        </div>
                        {ConDespacho}
                        <div className="row">
                            <div className="col despachar-tabla">
                                {table}
                            </div>
                        </div>
                        {
                            ordenUbicacion && ordenUbicacion.Instrucciones_Entrega ?
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group general">
                                            <label>Instrucciones de Entrega</label>
                                            <p>{ordenUbicacion.Instrucciones_Entrega}</p>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="custom-control custom-checkbox ml-0 mt-3">
                                            <input type="checkbox"
                                                className="custom-control-input"
                                                id="chkConfirmoLectura"
                                                checked={confirmoLectura}
                                                onChange={this.onChangeConfirmoLectura}
                                            />
                                            <label class="custom-control-label bold" htmlFor="chkConfirmoLectura">
                                                Confirmo lectura de instrucciones
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                : null
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.props.onClickCancelar}>Cancelar</button>
                        <button type="button" className={` btn  ${Eliminar ? 'btn-primary' : 'btn-secondary'}`} data-dismiss="modal" onClick={this.props.onClickEliminar}>Eliminar {this.props.procesandoEliminar ? <FontAwesomeIcon className="ml-1" icon={faSpinner} spin /> : null}</button>
                        <button type="button" className={` btn ${AnularDespacho ? 'btn-secondary' : 'btn-primary'}`} onClick={this.onClickBtnDespachar} disabled={!this.props.habilitarBotonDespacho}>Despachar {!this.props.habilitarBotonDespacho ? <FontAwesomeIcon className="ml-1" icon={faSpinner} spin /> : null}</button>
                    </Modal.Footer>
                </Modal>
                <Modal show={showModalValidacion} onHide={this.onCloseModalValidacion} keyboard={false} enforceFocus={false} backdropClassName="modal-backdrop-secondary">
                    <Modal.Header closeButton>
                        <Modal.Title><h5 className="modal-title">Confirmación de código de artículo</h5></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-12">
                                <Form.Group>
                                    <Form.Label>Código</Form.Label>
                                    <InputGroup className="mb-3">
                                        <FormControl
                                            placeholder="Código de artículo"
                                            aria-label="Código de artículo"
                                            aria-describedby="basic-addon2"
                                            maxLength="25"
                                            value={codigoValidar}
                                            onChange={this.onChangeCodigoValidacion}
                                            onKeyDown={this.onKeyDownCodigoValidacion}
                                        />
                                        <InputGroup.Append>
                                            <Button onClick={this.onClickBtnValidar} variant="primary">
                                                <FontAwesomeIcon icon={faCheck} size={2} />
                                            </Button>
                                        </InputGroup.Append>
                                    </InputGroup>
                                </Form.Group>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary" onClick={this.onCloseModalValidacion}>
                            Salir
                        </button>
                    </Modal.Footer>
                </Modal>
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        token: state.usuario.token,
        empresa: state.parametros.empresa,
        callCenter: state.parametros.callCenter,
        sucursal: state.parametros.sucursal
    };
};

export default connect(mapStateToProps)(memo(despacharOrdenes));